














import { Component, Prop, Model, Emit, Vue } from "vue-property-decorator";

@Component
export default class InputTextBox extends Vue {
  @Model("change", { type: Array }) values!: [string];
  @Prop({ required: true }) private answerId!: string;
  @Prop() private icon!: string;

  get isActive() {
    return this.values.includes(this.answerId);
  }

  @Emit("change")
  private onClick(): [string] {
    if (this.values.includes(this.answerId)) {
      //Remove item from values array
      const index = this.values.indexOf(this.answerId);
      this.values.splice(index, 1);
    } else {
      //Push item to values array
      this.values.push(this.answerId);
    }

    //Emit new values array
    return this.values;
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,

      "--bg-color-active": this.$store.state.globalCss.colors.inputTextBox
        .backgroundColorActive,
      "--bg-color-inactive": this.$store.state.globalCss.colors.inputTextBox
        .backgroundColorInactive,
      "--color-active": this.$store.state.globalCss.colors.inputTextBox
        .colorActive,
      "--color-inactive": this.$store.state.globalCss.colors.inputTextBox
        .colorInactive
    };
  }
}
